export default class WrapperInit
{
    static init(): void
    {
        //
        // LOGGING
        //
        const url: URL = new URL( window.location.href );
        const verboseLogLevel: string | null = url.searchParams.get( '__vll' );

        if ( verboseLogLevel )
        {
            localStorage.setItem( 'al_verbose_log_level', verboseLogLevel );
        }

        //
        // VIEWPORT CONFIGURATION
        //
        let initialScale = '1.0';
        const isMobileDevice: boolean = /iPhone|iPad|iPod|Android/i.test( navigator.userAgent );

        if ( isMobileDevice )
        {
            initialScale = '0.5';
        }

        const metaTag: HTMLMetaElement = document.createElement( 'meta' );

        metaTag.name = 'viewport';
        metaTag.content = 'width=device-width, initial-scale=' + initialScale;
        (document.head as HTMLHeadElement).appendChild( metaTag );

        //
        // MARK THIS PAGE AS TOP LEVEL
        //
        window[ 'al_is_top_level' ] = true;
    }
}
